module.exports = __webpack_public_path__ + "img/xero_analysis.0b7d4d02.svg";